import React,{useRef, useEffect} from 'react';
import './App.css';
import {BiUpArrowAlt} from "react-icons/bi"
import {OpenAi,Home,Footer,Info,About,Library,CaseStudy} from "./container"
function App() {

  const elementRef = useRef(null)

  useEffect(() => {
    const divElement = elementRef.current;
  
    divElement.addEventListener("click", function () {
      if (window.scrollY > 0) {
        window.scrollTo(0,0);
      }
    })

    window.addEventListener("scroll", function () {
      if (window.scrollY > 600) {
        divElement.style.opacity = 1;
      } else {
        divElement.style.opacity = 0;
      }
    })
    
  },[])
  return (
    <div>
      <Home />
      <About />
      <CaseStudy />
      {/* <Info /> */}
      <OpenAi />
      <Library />
      <Footer />
      <div className="arrowUp"
       ref = {elementRef}
      >
        <BiUpArrowAlt
        
        />
      </div>
    </div>
  );
}

export default App;
